import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addNewPost } from '../actions/index'
import { itemsFetchStaticCategories } from '../actions/index'
import { Link } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'


class NewPost extends Component {

  state = {
    titleInput: "",
    bodyInput: "",
    categoryInput: "Primary 1",
    categoryID: 1,
    postSaved: false,
    newCategories: [],
    image: ""
  }

  titleInput = (event) => {
    this.setState({titleInput: event.target.value})
  }

  bodyInput = (event) => {
    this.setState({bodyInput: event.target.value})
  }

  categoryInput = (event) => {
    if (event.target.value === 'Primary 1') {
      let categoryID = 1
      this.setState({categoryID})
    } else if (event.target.value === 'Primary 2') {
      let categoryID = 2
      this.setState({categoryID})
    } else if (event.target.value === 'Primary 3') {
      let categoryID = 3
      this.setState({categoryID})
    } else if (event.target.value === 'Primary 4') {
      let categoryID = 4
      this.setState({categoryID})
    } else if (event.target.value === 'Primary 5') {
      let categoryID = 5
      this.setState({categoryID})
    } else if (event.target.value === 'Preparatory 2') {
      let categoryID = 8
      this.setState({categoryID})
    } else if (event.target.value === 'Preparatory 3') {
      let categoryID = 9
      this.setState({categoryID})
    } else if (event.target.value === 'Secondary 1') {
      let categoryID = 10
      this.setState({categoryID})
    } else if (event.target.value === 'Secondary 2') {
      let categoryID = 11
      this.setState({categoryID})
    }

    this.setState({categoryInput: event.target.value})
  }

  postSubmit = (event) => { 

    // update store and API with new post
    this.props.addPost(this.state.titleInput, this.state.bodyInput, this.state.categoryInput, this.state.categoryID, this.props.currentUser.email, this.props.currentUser.user_metadata.full_name, this.state.image)

    this.setState({
      postSaved: true,
      titleInput: "",
      bodyInput: "",
      categoryInput: "Primary 1"
    })
    

    event.preventDefault()
  }

  componentDidMount() {
    this.props.fetchCategories();

    // check if a Facebook user with an image and if so add that to state
    if (this.props.currentUser.image) {
      this.setState({image: this.props.currentUser.image})
    }
  }

  /*
  updateCategories() {
    let newCategories = this.props.categories
    newCategories.unshift({name: "Please choose...", path: "Choose"});
    this.setState({newCategories: newCategories});
  }
  */


  render() {

    return (
      <div>
          <Header />

          {(!this.props.staticCategories.length)
          ? <div>Loading...</div>
          :
          
          <div style={{textAlign: 'center'}}>
          <h1>Create a new topic</h1>
          <form onSubmit={this.postSubmit}>
              <label>
                Title<br/> 
                <input className="new-title" placeholder="Post title" type="text" value={this.state.titleInput} onChange={this.titleInput} required></input>
              </label><br/>
              <label>
                Post<br/>
                <textarea rows="10" placeholder="Your post" value={this.state.bodyInput} onChange={this.bodyInput} required></textarea>
              </label><br/>
              <label>
              Choose a category<br/>
              <select onChange={this.categoryInput}>
                { this.props.staticCategories.map( category => <option key={category.name} value={category.name}>{category.name}</option>
                )}
              
              
              </select>
              </label><br/>
              <input className= "purple-button" type="submit" value="Submit" />
          </form>
          </div>
          }

          { (this.state.postSaved === true)
          ?
            <div className="post-saved-alert" style={{textAlign: 'center'}}>
            <p>Your topic has been saved</p>
            <Link to={"/post/" + this.props.activePost}>View topic</Link>
            </div>
          : <p></p>
          }
      
        <Footer />




        

      </div>



    )
  }

}

const mapStateToProps = (state) => {
  
  return {
      staticCategories: state.staticCategories,
      activePost: state.activePost._id,
      currentUser: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addPost: (title, body, category, categoryID, authorEmail, authorName, image) => dispatch(addNewPost(title, body, category, categoryID, authorEmail, authorName, image)),
    fetchCategories: () => dispatch(itemsFetchStaticCategories())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPost);


// WEBPACK FOOTER //
// ./src/components/NewPost.js